import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { ServicePayment } from 'types';
import { SERVICE_PAYMENTS_HEADER_TITLES } from 'utils/constants';
import { DATE_FORMAT, SERVICE_PAYMENTS_FIELD_NAME } from 'utils/enums';
import { convertCoinsToUAH, getLocaleAmountString } from 'utils/helpers';

export const COLUMNS_CONFIG: GridColDef<ServicePayment>[] = [
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.CREATED_AT,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.CREATED_AT,
		flex: 1.2,
		sortable: true,
		valueGetter: (_: unknown, row: ServicePayment) => dayjs.utc(row.createdAt).format(DATE_FORMAT.DATE_FULL),
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.PAID_AT,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.PAID_AT,
		flex: 1.2,
		sortable: true,
		valueGetter: (_: unknown, row: ServicePayment) =>
			row.paidAt ? dayjs.utc(row.paidAt).format(DATE_FORMAT.DATE_FULL) : undefined,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.PARTNER,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.PARTNER,
		flex: 1,
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.MAIN_BILL_ID,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.MAIN_BILL_ID,
		flex: 0.8,
		valueGetter: (_: unknown, row: ServicePayment) => row.mainBillId,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.CHILD_BILL_ID,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.CHILD_BILL_ID,
		flex: 1,
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.PARENT_BILL_ID,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.PARENT_BILL_ID,
		flex: 1,
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.SEPARATION_TYPE,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.SEPARATION_TYPE,
		flex: 0.8,
		valueGetter: (_: unknown, row: ServicePayment) => row.separationType,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.SERVICE_PROVIDER,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.SERVICE_PROVIDER,
		flex: 0.8,
		sortable: false,
		valueGetter: (_: unknown, row: ServicePayment) =>
			row?.serviceTitle ?? row.serviceData?.at(0)?.regDataObject?.description,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.SERVICE_NAME,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.SERVICE_NAME,
		flex: 0.8,
		sortable: false,
		valueGetter: (_: unknown, row: ServicePayment) => row.payerData?.providerService,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.BANK,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.BANK,
		flex: 1,
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.PAID_AMOUNT,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.AMOUNT,
		flex: 1,
		valueGetter: (_: unknown, row: ServicePayment) =>
			getLocaleAmountString(convertCoinsToUAH(Number(row.amount) - Number(row.fee))),
		align: 'right',
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.FEE,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.FEE,
		flex: 1,
		sortable: false,
		valueGetter: (_: unknown, row: ServicePayment) => getLocaleAmountString(convertCoinsToUAH(row.fee)),
		align: 'right',
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.AMOUNT,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.PAID_AMOUNT,
		flex: 1,
		sortable: true,
		valueGetter: (_: unknown, row: ServicePayment) => getLocaleAmountString(convertCoinsToUAH(row.amount)),
		align: 'right',
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.STATUS,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.STATUS,
		flex: 1,
		sortable: false,
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.CLIENT_PHONE,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.CLIENT_PHONE,
		sortable: false,
		flex: 1,
		valueGetter: (_: unknown, row: ServicePayment) => {
			const phone = row.payerData.clientPhone;

			return phone ? `+${row.payerData.clientPhone}` : undefined;
		},
	},
	{
		field: SERVICE_PAYMENTS_FIELD_NAME.CARD,
		headerName: SERVICE_PAYMENTS_HEADER_TITLES.CARD,
		flex: 1,
		sortable: false,
	},
];

export const DEFAULT_SERVICE_PAYMENT_FILTERS = {
	gte: null,
	lte: null,
	services: [],
	provider: [],
	status: [],
	amountFrom: '',
	amountTo: '',
	providerId: '',
	serviceId: '',
	mainBillId: '',
};
